import React from "react";
import PropTypes from "prop-types";

const ContentBlock = ({ children, color, tag, heading, id }) => {
  const blockClass = "m-content-block";
  const bgColorClass = `a-bg-${color || "white"}`;
  const Tag = tag || "section";

  return (
    <Tag
      className={`${blockClass} ${blockClass}--block ${bgColorClass}`}
      id={id}
    >
      <div className={`${blockClass}__inner`}>
        {heading && (
          <header className={`${blockClass}__header`}>
            <h2>{heading}</h2>
          </header>
        )}
        {children}
      </div>
    </Tag>
  );
};

ContentBlock.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  tag: PropTypes.string,
  heading: PropTypes.string,
  id: PropTypes.string,
};

export default ContentBlock;
